var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._l((_vm.filterHeaders()),function(column){return [(column.key === 'icons')?_c('td',{key:column.key,staticClass:"b2b-grid__cell lg:table-cell",class:[
        {
          'whitespace-nowrap': column.key === 'icons',
        },
        column.cssClasses ],attrs:{"qaid":"shipment.grid.row.notes"}},[_c('div',{staticClass:"flex flex-nowrap"},[(_vm.item.isSplitWarehouse)?_c('grid-icon',{attrs:{"data":{
            value: 'call_split',
          }}}):_vm._e(),_c('grid-note',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.lineComment),expression:"item.lineComment"}],attrs:{"row-id":_vm.item.id,"data":{
            value: 'insert_drive_file',
            content: _vm.item.lineComment,
            editable: _vm.notesEditable,
            cssClass: 'ml-1',
          },"base-properties":_vm.baseProperties}})],1)]):_c('grid-cell',{key:column.key,attrs:{"cell-key":column.key,"label":column.label,"qaid":("order-detail-item-" + (column.key)),"value":column.key !== 'lineStatus' ? _vm.item[column.key] : null,"classes":[
        {
          'whitespace-nowrap': column.key === 'lineStatus' || column.key === 'icons',
          'w-1': column.key !== 'itemName',
        },
        column.cssClasses ]}},[(column.key === 'lineStatus')?_c('tk-badge',{class:_vm.calculateBadgeClass(_vm.item[column.key])},[_vm._v(" "+_vm._s(_vm.bp(_vm.item[column.key]))+" ")]):_vm._e()],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }